/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY.
const u = undefined;

function plural(val: number): number {
const n = val;

return 5;
}

export default ["kok-Latn",[["AM","PM"],u,["sokallim","sanje"]],u,[["A","S","M","B","B","S","S"],["Ait","Som","Mon","Bud","Bre","Suk","Son"],["Aitar","Somar","Mongllar","Budhvar","Birestar","Sukrar","Sonvar"],["Ai","Sm","Mg","Bu","Br","Su","Sn"]],u,[["J","F","M","A","M","J","J","A","S","O","N","D"],["Jan","Feb","Mar","Abr","Mai","Jun","Jul","Ago","Set","Otu","Nov","Dez"],["Janer","Febrer","Mars","Abril","Mai","Jun","Julai","Agost","Setembr","Otubr","Novembr","Dezembr"]],u,[["K","A"],["KA","AD"],["Krista Adim","Anno Domini"]],0,[0,0],["d-M-yy","d MMM, y","d MMMM, y","EEEE, d MMMM, y"],["a h:mm","a h:mm:ss","a h:mm:ss z","a h:mm:ss zzzz"],["{1}, {0}",u,u,u],[".",",",";","%","+","-","E","×","‰","∞","NaN",":"],["#,##,##0.###","#,##0%","¤#,##,##0.00","#E0"],"INR","₹",u,{"JPY":["JP¥","¥"],"USD":["US$","$"]},"ltr", plural];
